import { render } from "./OfferPDC.vue?vue&type=template&id=fd2ff4cc"
import script from "./OfferPDC.vue?vue&type=script&lang=js"
export * from "./OfferPDC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__